import React from 'react';
import { Container } from 'react-bootstrap';

const Hero = ({ texts }) => {
    return (
        <section id="home" className="hero-section d-flex align-items-center text-center">
            <Container>
                <h1 className="display-4 text-white">{texts.hero.title}</h1>
                <p className="lead text-white">{texts.hero.subtitle}</p>
                <p className="text-white">{texts.hero.description}</p>
            </Container>
        </section>
    );
};

export default Hero;